import type { InputHTMLAttributes } from "react";
import { formatCep, normalizeCep } from "@cx/domain";

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> & {
  value: string;
  onChange(v: string): void;
  onResolved?: (cep: string) => void;
};

export function CepInput({ value, onChange, onResolved, className = "form-control", ...rest }: Props) {
  const marked = rest["aria-invalid"] === "true" || rest["aria-invalid"] === true;
  return (
    <input
      {...rest}
      inputMode="numeric"
      maxLength={9}
      placeholder="00000-000"
      className={`${className}${marked ? " is-invalid" : ""}`}
      value={value.length === 8 ? formatCep(value) : value}
      onChange={(e) => {
        const raw = e.target.value;
        onChange(raw);
        const n = normalizeCep(raw);
        if (n) {
          onChange(n);
          onResolved?.(n);
        }
      }}
    />
  );
}
